import * as React from "react";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/image-gallery.css";
import "../../css/product-image-gallery-overrides.scss";
import { GalleryItem } from "react-image-gallery";

function renderThumbnail(item: GalleryItem) {
  const thumbnail = item.thumbnail || item.original;

  return (
    <span className="hgs-gallery-thumbnail-content">
      <img
        className="image-gallery-thumbnail-image hgs-gallery-thumbnail-image"
        src={thumbnail}
        alt={item.thumbnailAlt || item.originalAlt || ""}
        title={item.thumbnailTitle}
      />
      {item.thumbnailLabel && (
        <span className="hgs-gallery-thumbnail-label">
          {item.thumbnailLabel}
        </span>
      )}
    </span>
  );
}

/**
 * Wrapper for ImageGallery that conditionally hides the thumbnails
 */
export const HgsImageGallery: React.FC<{ items: GalleryItem[] }> = (props) => {
  const showThumbnails = props.items.length >= 2;
  return (
    <ImageGallery
      items={props.items}
      showPlayButton={false}
      showThumbnails={showThumbnails}
      additionalClass="hgs-image-gallery"
      renderThumbInner={renderThumbnail}
    />
  );
};
